import * as React from "react";
const SvgFiRrPersonDress = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M9.5 2.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0m10.186 11.228A1 1 0 0 1 19 14a1 1 0 0 1-.728-.314l-1.918-2.036.622 4.978a3 3 0 0 1-.728 2.357 3 3 0 0 1-1.249.826v3.188a1 1 0 0 1-2 0v-3h-2v3a1 1 0 0 1-2 0v-3.188a3 3 0 0 1-1.249-.826 3 3 0 0 1-.728-2.357l.621-4.964-1.918 2.024a.998.998 0 0 1-1.414.038 1 1 0 0 1-.038-1.414l4.471-4.719A4.13 4.13 0 0 1 12 6c1.166 0 2.221.501 2.98 1.294.018.017 4.748 5.02 4.748 5.02.378.402.36 1.035-.042 1.414zm-9.4-4.851c-.21.285-.355.62-.402.991l-.876 7.008a.99.99 0 0 0 .243.786.99.99 0 0 0 .75.338h4c.291 0 .557-.12.75-.338a.99.99 0 0 0 .243-.786l-.876-7.008A2.136 2.136 0 0 0 12.002 8c-.509 0-.977.185-1.347.488l-.368.389z"
    />
  </svg>
);
export default SvgFiRrPersonDress;
